import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=27cd0b50&scoped=true&"
import script from "./UserLayout.vue?vue&type=script&lang=ts&"
export * from "./UserLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd0b50",
  null
  
)

export default component.exports